module.exports = __webpack_public_path__ + "static/media/mapping.557a207b.md";